
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.75 4c1.603 0 3.189.626 4.406 1.844 2.435 2.435 2.435 6.409 0 8.844l-1.469 1.469a6.205 6.205 0 01-3.625 1.781l-.25-2a4.1 4.1 0 002.438-1.188h.031l1.469-1.469c1.671-1.671 1.671-4.36 0-6.031s-4.36-1.671-6.031 0L17.25 8.719a4.183 4.183 0 00-1.188 2.469l-2-.25a6.208 6.208 0 011.781-3.625l1.469-1.469A6.285 6.285 0 0121.75 4zM7.719 6.281l4 4-1.438 1.438-4-4zm3.219 7.782l.25 2a4.1 4.1 0 00-2.438 1.188h-.031L7.25 18.72c-1.671 1.671-1.671 4.36 0 6.031s4.36 1.671 6.031 0l1.469-1.469a4.183 4.183 0 001.188-2.469l2 .25a6.208 6.208 0 01-1.781 3.625l-1.469 1.469c-2.435 2.435-6.409 2.435-8.844 0s-2.435-6.409 0-8.844l1.469-1.469a6.205 6.205 0 013.625-1.781zm10.781 6.218l4 4-1.438 1.438-4-4z"}})])
          )
        }
      }
    